import React, { useEffect, useState } from "react";
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import MultipleChipSelect from "./MultipleChipSelect"
import TsvTemplate from "./TsvTemplate"
import TsvUploader from "../../../components/TsvUploader";

const config = window.config;

const ExperimentBatchTsv =(props)=>{


    return(
        <Grid 
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
        >
            <Grid item>
                <Card sx={{ m:2, minWidth: 410 }}>
                    <Typography variant={"h6"} sx={{m:2}}> 1. Get TSV experiment template file </Typography>
                    <FormControl sx={{ m: 2, width: 400 }}>
                        <MultipleChipSelect
                            label={"Select Experiment Fields"}
                            fields={props.fields}
                            setFields={props.setFields}
                            availableFields={config.experimentEditionFields}
                            minWidth={400}
                        />
                        { props.fields.length !== 0 ?   
                            <TsvTemplate
                                onClick={props.downloadTsvTemplate}
                            />
                          : 
                            null
                        }
                    </FormControl>
                </Card>
            </Grid>
            <Grid item >
                <Card sx={{ m:2, minWidth: 150 }}>
                    <Typography variant={"h6"} sx={{m:2}}> 2. Upload TSV experiment edition batch file </Typography>
                    <center><TsvUploader uploadTsv={props.uploadTsv}/></center>
                </Card>
            </Grid>
        </Grid>               
    );
}

export default ExperimentBatchTsv;